import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { getImages } from '../const';

const SavedSearchesModal = ({ close, setOpenFilterModal, handleSaveEdit, handleDelete, openSavedSearchesModal, setEditItemValues }) => {
    const [saveValues, setSaveValues] = useState([]);
    useEffect(() => {
        const savedData = localStorage.getItem("filterCompleteData");
        if (savedData) {
            setSaveValues(JSON.parse(savedData));
        }
    }, [openSavedSearchesModal]);

    const handleSavedDataSubmit = (values, { resetForm }) => {
        console.log("submitting saved search",values);
        close();
        setEditItemValues(values);
    };


    const handleNewSearch = () => {
        setOpenFilterModal(true);
        close();
    }

    const updateTitleInput = (title,index) => {

        const updatedItem = saveValues.map((item,i) => {
            if (i == index) {
                item.searchtitle = title
            }
            return item;
        });

        setSaveValues(updatedItem);
    }

    const updateTitle = (title,id) => {

        const updatedItem = saveValues.map((item) => {
            if (item.id == id) {
                item.searchtitle = title
            }
            return item;
        });
        
        localStorage.setItem('filterCompleteData', JSON.stringify(updatedItem));
    }

    return (
        <>
        {/* {console.log("saveValues", saveValues)} */}
            <div className="modal-content saved-search-modal p-0">
                <div className="modal-header p-3 chat-modal-header">
                    <h1 className="modal-title filter-modal-title text-center w-100">
                        Saved Searches
                    </h1>
                    <button className="sm-box-close mt-0" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                </div>
                <div className="modal-body p-4">
                    <div className='d-flex align-items-center justify-content-between mb-3'>
                        <div className='sm-title text-uppercase'>Here are your recent searches</div>
                        <div>
                            <button type='button' className='red-btn' onClick={handleNewSearch}>New Search</button>
                        </div>
                    </div>
                    {saveValues.length > 0 &&
                        saveValues.map((inItem, i) =>
                            <div key={i}>
                                <Formik
                                    initialValues={{
                                        make: inItem.make || [],
                                        year: inItem.year || '',
                                        miles: inItem.miles || '',
                                        dom: inItem.dom || '',
                                        price: inItem.price || '',
                                        zipCode: inItem.zipCode || '',
                                        milesZipCode: inItem.milesZipCode || ''
                                    }}
                                    onSubmit={handleSavedDataSubmit}
                                >
                                    {({ values, errors, touched, setFieldValue, resetForm, isSubmitting, initialValues }) => {
                                        const isSearchTitleChanged = values.searchtitle !== initialValues.searchtitle;

                                        return (
                                            <Form className="custom-form w-100" autoComplete="off" name="filter-form">
                                                <div key={`save-search-${i}`} className='filter-option-box save-search-box'>
                                                    <div className='mb-3 d-flex align-items-center justify-content-between'>
                                                        <div>
                                                            <Field
                                                                type="text"
                                                                name="searchtitle"
                                                                className="range-vlu-form w-auto"
                                                                placeholder={"Saved Search " + (i+1)}
                                                                value={inItem.searchtitle || "Saved Search " + (i+1)}
                                                                onChange={(e) => {updateTitleInput(e.target.value,i)}}
                                                                onBlur={(e) => {updateTitle(e.target.value,inItem.id)}}
                                                            />
                                                            {errors.searchtitle && touched.searchtitle && (
                                                                <div className="error-message">{errors.searchtitle}</div>
                                                            )}
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <button type='button' className='transparent-btn text-uppercase'
                                                                    onClick={() => {
                                                                        handleSaveEdit(inItem);
                                                                        close();
                                                                    }}
                                                                >
                                                                    <span className='sv-edit-icon'></span> Edit</button>
                                                                <button type='button' className='transparent-btn text-uppercase'
                                                                    onClick={() => {
                                                                        handleDelete(inItem.id);
                                                                        close();
                                                                    }}
                                                                ><span className='sv-delete-icon'></span> Delete</button>
                                                                <button type='submit' className='red-transparent-btn text-uppercase'>Apply</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {inItem?.make?.length > 0 &&
                                                        inItem.make.map((item, i) => (
                                                            item.models.map((modelItem, i) => (
                                                                <span key={`make-${i}`} className='search-tag d-inline-block'>
                                                                    {modelItem}
                                                                    <img
                                                                        src={getImages('icon-exit.svg')}
                                                                        alt="Remove"
                                                                    />
                                                                </span>)
                                                            ))
                                                        )}
                                                    {inItem?.year?.length > 0 &&
                                                        <span className='search-tag d-inline-block'>
                                                            {inItem.year[0]} - {inItem.year[1]}
                                                            <img
                                                                src={getImages('icon-exit.svg')}
                                                                alt="Remove"
                                                            />
                                                        </span>
                                                    }
                                                    {inItem?.miles?.length > 0 &&
                                                        <span className='search-tag d-inline-block'>
                                                            {inItem.miles[0]}k - {inItem.miles[1]}k
                                                            <img
                                                                src={getImages('icon-exit.svg')}
                                                                alt="Remove"
                                                            />
                                                        </span>
                                                    }
                                                    {inItem?.dom?.length > 0 &&
                                                        <span className='search-tag d-inline-block'>
                                                            {inItem.dom[0]} - {inItem.dom[1]}
                                                            <img
                                                                src={getImages('icon-exit.svg')}
                                                                alt="Remove"
                                                            />
                                                        </span>
                                                    }
                                                    {inItem?.price?.length > 0 &&
                                                        <span className='search-tag d-inline-block'>
                                                            ${inItem.price[0]}k - ${inItem.price[1]}k
                                                            <img
                                                                src={getImages('icon-exit.svg')}
                                                                alt="Remove"
                                                            />
                                                        </span>
                                                    }
                                                    {inItem?.zipCode?.length > 0 &&
                                                        <span className='search-tag d-inline-block'>
                                                            {inItem.zipCode}
                                                            <img
                                                                src={getImages('icon-exit.svg')}
                                                                alt="Remove"
                                                            />
                                                        </span>
                                                    }
                                                    {inItem?.milesZipCode?.length > 0 &&
                                                        <span className='search-tag d-inline-block'>
                                                            {inItem.milesZipCode[1]}
                                                            <img
                                                                src={getImages('icon-exit.svg')}
                                                                alt="Remove"
                                                            />
                                                        </span>
                                                    }
                                                </div>
                                            </Form>
                                        )
                                    }}
                                </Formik>
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default SavedSearchesModal